import { ARTICLE_TYPE, PHOTO_TYPE, VIDEO_TYPE } from 'interfaces'
import { createAppAsyncThunk } from 'store/state'
import { articleAdapter } from '../adapters/articles'
import { photoAdapter } from '../adapters/photos'
import { videoAdapter } from '../adapters/videos'
import { V1 } from './net'

import { firstValueFrom } from 'rxjs'
import { ContentType } from 'shared'

export const getStreamsContent = createAppAsyncThunk(
  'content/getStreamsContentBatch',
  async (streams: { [key: string]: { filters: ContentType[], originalStreamId?: string } }, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getContent(streams)))
      const streamsData = response.streams
      if (!streamsData) {
        return []
      }

      return Object.keys(streams).map(id => {
        const content = streamsData[id]
        if (!content) {
          return { id, content: [] }
        }

        const items = Object.keys(content)
          .map(filter => {
            switch (filter) {
              case ARTICLE_TYPE:
                return content[filter].data.map(articleAdapter)
              case PHOTO_TYPE:
                return content[filter].data.map(photos => photoAdapter(photos))
              case VIDEO_TYPE:
                return content[filter].data.map(videos => videoAdapter(videos))
              default:
                return []
            }
          })
          .reduce((allItems: any[], itemsByFilter) => allItems.concat(itemsByFilter), [])

        return { id, content: items }
      })
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)
